import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useParams, useHistory } from 'react-router-dom'
import { ROUTE_DATA } from '../../../components/lhs/__mock'

import {
  getDistinctValues,
  getImageUrl,
  removeSpecialCharFromLhs,
  scrollByPxFromCurrentPosition,
  getLogData,
  smoothScrollToTarget,
  fakeDelay,
} from '../../../util'
import { ROLES_ALL, ROLES_CLIENT_SECONDARY, ROLES_MM_PRIMARY } from '../../../constants'
import { BlockingLoader, Loader, MuiButton } from '../../../components'
import reportsService from '../../../services/reports.service'
import nodeService from '../../../services/node.service'
import { IconClose } from '../../../assets/images/iconsV2'
import { useGlobalStore } from '../../../store'
import { getPageScrollLength } from '../../../util'
import {
  OuterNavSection,
  CaseStudy,
  ClientDetails,
  PhaseSelectLabel,
  MenuNavigations,
  MenuList,
  MenuListContent,
  MenuListWrapper,
  LogoWrapper,
  LogoText,
} from './style'
// import items from "./sideBar.json";

const SideNavSection = ({ onChange, hideLhsMenu , headerHamburgerActive }) => {
  const { id } = useParams()
  const navigate = useHistory()
  const [reportsLhsData, setReportsLhsData] = useState([])
  const [selectedTab, setSelectedTab] = useState(null)
  const [isSubTabsLoading, setSubTabsLoading] = useState(false)
  const { pathname, hash } = useLocation()
  const { user, subLhs, setSubLhs, setLhs, company, showLhsMenu, setShowLhsMenu, isFullScreen, setCurrentTabId } = useGlobalStore()

  const isreportpage = true
  const logoPath = getImageUrl('logos/default', company?.CompanyLogo, 'svg')

  const [openIndex, setOpenIndex] = useState(0)
  const [activeSubIndex, setActiveSubIndex] = useState({})
  const [sandBoxDetails, setSandBoxDetails] = useState(null)

  const projectIdValue = getLogData('GetStudies', 'GetStudies', {}, { StudyId: id })[0]

  const toggleSubMenu = (index) => {
    if (openIndex === index) return false
    setOpenIndex(index)
  }

  ///////////////////////////////////////////////

  const reportTabData = (resp, tabId) => {
    const lhsTabsRes = resp
      .sort((a, b) => a.InsightsElementOrder - b.InsightsElementOrder)
      .filter((t) => t.InsightsElementVisible)
      .map((list) => {
        list.active = false
        list.tabContent = null
        list.isApiLoading = true
        // list.Title = (list?.Title)?.replace(/[^a-zA-Z0-9 ]/g, '') || ''
        list.Title = list.Title.replaceAll(':', ' - ')
        list.ParentTitleIndex = 0
        return list
      })

    const lhsTabsLevel3Objects = {}
    const lhsTabsResFinal = []
    for (let i = 0; i < lhsTabsRes.length; i++) {
      if (i === 0) {
        lhsTabsRes[i].ParentTitleIndex = 0
      } else if (
        lhsTabsRes[i].ParentTitle !== '' &&
        lhsTabsRes[i].ParentTitle === lhsTabsRes[i - 1].ParentTitle
      ) {
        lhsTabsRes[i].ParentTitleIndex = lhsTabsResFinal[i - 1].ParentTitleIndex + 1
      }
      if (lhsTabsRes[i].ParentTitle !== '' && lhsTabsRes[i].ParentTitleIndex === 0) {
        lhsTabsLevel3Objects[lhsTabsRes[i].ParentTitle.replaceAll(' ', '')] = []
      }
      lhsTabsResFinal.push(lhsTabsRes[i])
    }

    for (let j = 0; j < lhsTabsRes.length; j++) {
      if (lhsTabsRes[j].ParentTitle !== '') {
        lhsTabsLevel3Objects[lhsTabsRes[j].ParentTitle.replaceAll(' ', '')].push(lhsTabsRes[j])
      }
    }

    for (let k = 0; k < lhsTabsRes.length; k++) {
      if (lhsTabsRes[k].ParentTitle !== '' && lhsTabsRes[k].ParentTitleIndex === 0) {
        lhsTabsRes[k].ParentTitleArray =
          lhsTabsLevel3Objects[lhsTabsRes[k].ParentTitle.replaceAll(' ', '')]
      }
    }

    if (lhsTabsResFinal?.length > 0) {
      setSubLhs([...lhsTabsResFinal])
    }
  }

  const getSubHeadings = (tabId) => {
    setSubTabsLoading(true)

    const oldApiFunc = () => {
      reportsService.reportTabsApi({ studyId: id, tabId })
      .then((resp) => {
        reportTabData(resp, tabId)
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        setSubTabsLoading(false)
      })
    }

    // if(projectIdValue?.IsFreezed){
    // NOTE: cannot use this IF logic due to this scenario:
    // if the study is freezzed and then unfreezed then the API will not hit and will not be able to delete the server folder..
      nodeService.getInsightsElementsForTab({payload: {studyId: id, tabId, isFreezed:projectIdValue.IsFreezed }})
        .then(d => { 
          reportTabData(d.data, tabId)
          setSubTabsLoading(false)
        }) 
        .catch(err => oldApiFunc())
    // } else {
    //   oldApiFunc()
    // }
  }

  useEffect(() => {
    if (selectedTab?.TabId && isreportpage) {
      getSubHeadings(selectedTab?.TabId)
      setCurrentTabId(selectedTab)
    }
  }, [selectedTab])

  useEffect(() => {
    if (isreportpage && subLhs?.length) {
      const elId = removeSpecialCharFromLhs(subLhs[0]?.Title)
      const el = document.querySelector(`#${CSS.escape(elId)}`)
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    }
  }, [subLhs])

  useEffect(() => {
    onChange({
      lhsLoading: isSubTabsLoading,
      selectedTab: selectedTab,
      subLhs: subLhs,
      sandBoxDetails: sandBoxDetails,
    })
  }, [isSubTabsLoading, onChange])

  const getLhsReportData = () => {
    reportsService
      .reportLhsApi({ studyId: id })
      .then((resp) => {
        let sandBoxObject = {}
        const sortedRespData = resp
          .sort((a, b) => a.TabOrder - b.TabOrder)
          // .filter((f) => f.TabVisible) // 
        const modifiedData = sortedRespData.map((list) => {
          list.userType = ['sandbox', 'snapshot', 'BusinessObjective'].includes(list.TabIcon) ? ROLES_ALL : ROLES_CLIENT_SECONDARY
          list.title = list.TabName
          list.label = list.TabName
          if (isreportpage) {
            list.icon = getImageUrl('icons', list.TabIcon, 'svg')
            list.href = `/reports/${list.TabIcon}/${id}`
          } else {
            list.icon = ROUTE_DATA[list.TabIcon].icon
            list.href = ROUTE_DATA[list.TabIcon].href + id
          }
          if (['sandbox', 'snapshot', 'BusinessObjective'].includes(list.TabIcon)) {
            sandBoxObject = list
          }
          return list
        })

        setSandBoxDetails(sandBoxObject)
        setLhs(modifiedData)
        setReportsLhsData(modifiedData)
        const activeTab = modifiedData.find((item) => pathname.includes(item.href))
        if (activeTab?.StudyId) {
          setSelectedTab(activeTab)
          toggleSubMenu(parseInt(activeTab.TabOrder) - 1)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    getLhsReportData()
  }, [])

  const hideLhs = () => {
    // rootRef.current.classList.remove('show')
  }

  const removeItemsL3Func = (arr) => {
    const distinctValues = getDistinctValues(
      arr.filter((f) => f?.ParentTitle !== '').map((d) => d?.ParentTitle)
    )
    const parentTitleAdded = []
    const arrFinal = []

    for (let i = 0; i < arr.length; i++) {
      if (distinctValues.includes(arr[i].ParentTitle)) {
        if (!parentTitleAdded.includes(arr[i].ParentTitle)) {
          const obj = { ...arr[i], Title: arr[i].ParentTitle, InsightsElementType: 'tabLevel3' }
          arrFinal.push(obj)
          parentTitleAdded.push(arr[i].ParentTitle)
        }
      } else {
        arrFinal.push(arr[i])
      }
    }
    return arrFinal
  }

  const lhsClickedFunc = async (e, id) => {
    e.preventDefault()
    const tabParent = document.getElementById(id)?.getAttribute('data-tabparent')
    // SCROLLING ADJUSTMENT2
    const object = getPageScrollLength(id)
    for (let i = 0; i < object.length; i++) {
      if (tabParent) {
        smoothScrollToTarget('lhs', id, 500, 'reportsContentSection', id)
        await fakeDelay(500)
        document.getElementById(id).querySelectorAll('a.nav-link')[0].click()
      } else {
        smoothScrollToTarget('lhs', id, 500, 'reportsContentSection')
        await fakeDelay(500)
      }
    }
  }

  useEffect(() => {
    hideLhs()
  }, [pathname, hash])

  // Login Time checking // max 15 hours
  const hoursCheck = () => {
    const diff_hours = (dt2, dt1) => {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000
      diff /= 60 * 60
      return Math.abs(Math.round(diff))
    }
    const loginedInHours = diff_hours(new Date(user?.loginTime), new Date())
    if (loginedInHours >= 15) {
      localStorage.clear()
      navigate.push('/')
    }
  }

  useEffect(() => {
    hoursCheck()
  }, [])

  useEffect(() => {
    if (showLhsMenu === 'projectPage' && isreportpage) {
      setShowLhsMenu('reportPage_showLhs')
    }
    scrollByPxFromCurrentPosition()
  }, [showLhsMenu])

  ///////////////////////////////////////////////



  return (
    <OuterNavSection>
      {isFullScreen && !headerHamburgerActive && (
        <LogoWrapper className='logoWrapper'>
          {company && logoPath && <LogoText src={logoPath} alt='' />}
          <MuiButton
            variant='text'
            color='light'
            size='small'
            startIcon={<IconClose />}
            onClick={() => hideLhsMenu()}
          />
        </LogoWrapper>
      )}
      {isSubTabsLoading && <BlockingLoader />}
      <ClientDetails>
        <CaseStudy>
          <PhaseSelectLabel className={`caseStudyPeriod ${isFullScreen ? '' : 'n-fullScreen'}`} title={projectIdValue?.Period || ''}>
            {projectIdValue?.Period || ''}
          </PhaseSelectLabel>
          {/* <PhaseSelect value="phase1" size="small" variant="outlined">
            <MenuItem>{projectIdValue?.Period || ''}</MenuItem>
          </PhaseSelect> */}
        </CaseStudy>
      </ClientDetails>

      <MenuNavigations isreportpage={+!!isreportpage} className={`lhsWrapper lhsLinks ${isFullScreen ? '' : 'n-fullScreen'}`}>
        {user &&
          selectedTab?.StudyId &&
          reportsLhsData.length > 0 &&
          reportsLhsData.map((list, i) => {
            const className = 'lhsLevel1_ ' + list.title.replaceAll(' ', '')
            const isOpen = openIndex === i
            const hideSandBox = list?.TabIcon?.toLowerCase() === 'sandbox' ? 'hideSandBox' : ''
            const hideSnapshot = list?.TabIcon?.toLowerCase() === 'snapshot' ? 'hideSnapshot' : ''
            let tabVisible = list.TabVisible || (!list.TabVisible && ROLES_MM_PRIMARY.includes(user?.UserType))

            return (
              <div key={i} className={`reports_list_${i} ${className} ${hideSandBox} ${hideSnapshot} ${isOpen?'selected':''}`}>
                {list.userType.includes(user?.UserType) && (
                  <MenuListWrapper key={list.title} className={list.activeLink} style={{ display: tabVisible ? 'block' : 'none' }}>
                    <MenuList
                      active={isOpen}
                      className={`MenuList ${(!list.TabVisible && ROLES_MM_PRIMARY.includes(user?.UserType)) ? 'semiTransparent' : ''}`}
                      to={list.href}
                      title={list.title}
                      onClick={() => {
                        toggleSubMenu(i)
                        setSelectedTab(list)
                      }}
                    >
                      {list.title}
                    </MenuList>

                    {isOpen && subLhs?.length > 0 && selectedTab?.TabName === list.label && (
                      <MenuListContent className='lhsLevel2'>
                        {removeItemsL3Func(subLhs).map((subItem, subIndex) => {
                          const id = `${removeSpecialCharFromLhs(subItem.Title)}_${subItem.InsightsElementId.replaceAll('-', '')}`
                          const hideSnapshot = subItem?.InsightsElementType?.toLowerCase() === 'snapshot' ? 'hideSnapshot' : ''
                          const isActive = activeSubIndex[i] === subIndex ? 'active' : ''

                          return (
                            <a
                              id={`lhs_${id}`}
                              key={subIndex}
                              className={`${hideSnapshot} ${isActive}`}
                              // onClick={() => setActiveSubIndex((prev) => ({ ...prev, [i]: subIndex })) }
                              href={`#id_${id}`}
                              data-target={`id_${id}`}
                              // onClick={(e) => lhsClickedFunc(e, `id_${id}`)}
                              onClick={(e) => {
                                lhsClickedFunc(e, `id_${id}`)
                                setActiveSubIndex({ [i]: subIndex })
                              }}
                            >
                              {subItem.Title}
                            </a>
                          )
                        })}
                      </MenuListContent>
                    )}
                  </MenuListWrapper>
                )}
              </div>
            )
          })}
      </MenuNavigations>
    </OuterNavSection>
  )
}

export default SideNavSection

SideNavSection.propTypes = {
  onChange: PropTypes.func,
  hideLhsMenu: PropTypes.func
}
